import type { ConceptFragment, Graph } from "@lr-notitia/notitia-designer/schemas";
import { Ref, computed } from "vue";
import { useSymbolsStore } from "../symbols";

let symbolsStore: ReturnType<typeof useSymbolsStore>;
function init() {
	symbolsStore = useSymbolsStore();
}

export const conceptFragments = (graph: Ref<Graph>) =>
	computed<ConceptFragment[]>(() => {
		if (!symbolsStore) init();
		return (
			Object.values(graph.value.nodes).filter(
				(node) => node.type === "fragment" && node.layer === "concept"
			) as ConceptFragment[]
		).sort((a, b) =>
			symbolsStore
				.term({ id: a.refersTo, terminology: a.terminology || {} })
				.toLocaleLowerCase()
				.localeCompare(symbolsStore.term({ id: b.refersTo, terminology: b.terminology || {} }).toLocaleLowerCase())
		);
	});
export function conceptFragment(domainId: Ref<string>, graph: Ref<Graph>) {
	return {
		byId: (id: string) => byId(id, graph),
	};
}

function byId(id: string, graph: Ref<Graph>): ConceptFragment | undefined {
	let hit = graph.value.nodes[id];
	return hit && hit.type === "fragment" && hit.layer === "concept" ? (hit as ConceptFragment) : undefined;
}
